/**
 *
 * @param value
 * @param enumObject
 * @return {string|null}
 */
export function getKey(value, enumObject) {
    for (var key in enumObject) {
        if (enumObject.hasOwnProperty(key)) {
            if (enumObject[key] === value) {
                return key;
            }
        }
    }
    return null;
}
/**
 *
 * @param enumObject
 * @return {string[]}
 */
export function getEnumKeys(enumObject) {
    return Object.keys(enumObject).filter(function (key) {
        return typeof enumObject[key] !== 'function' && !(parseInt(key) >= 0);
    });
}
